import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { LoadingSpinner } from './components/LoadingSpinner'

// Pages
import Landing from './pages/Landing'
import CustomerDashboard from './pages/CustomerDashboard'
import CustomerSignIn from './pages/CustomerSignIn'
import StaffLogin from './pages/StaffLoginPage'
import StaffAutoLogin from './pages/StaffAutoLogin'
import StaffDashboard from './pages/StaffDashboard'
import AdminDashboard from './pages/AdminDashboard'
import Scanner from './pages/Scanner'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import TermsAndConditions from './pages/TermsAndConditions'

function App() {
  const { user, staff, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/signin" element={<CustomerSignIn />} />
        <Route path="/staff/login" element={<StaffLogin />} />
        <Route path="/staff/auto-login" element={<StaffAutoLogin />} />
        
        {/* Legal pages */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        
        {/* Customer routes */}
        <Route 
          path="/dashboard" 
          element={
            user ? <CustomerDashboard /> : <Navigate to="/" replace />
          } 
        />
        
        {/* Staff routes */}
        <Route 
          path="/staff/dashboard" 
          element={
            staff ? <StaffDashboard /> : <Navigate to="/staff/login" replace />
          } 
        />
        <Route 
          path="/staff/scanner" 
          element={
            staff ? <Scanner /> : <Navigate to="/staff/login" replace />
          } 
        />
        
        {/* Admin routes */}
        <Route 
          path="/admin" 
          element={
            staff?.role === 'admin' ? <AdminDashboard /> : <Navigate to="/staff/login" replace />
          } 
        />
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}

export default App